import { api } from './api.js';

/** Autorização de oficina (dono gera; oficina ativa). */
export const authorizations = {
  list: (vehicleId) => api('GET', `/v1/vehicles/${encodeURIComponent(vehicleId)}/authorizations`),
  /** { type: 'SPECIFIC' | 'GENERIC', workshopId?, durationDays: 1|3|7|30 } → código de 6 dígitos + QR (30 min) */
  create: (vehicleId, body) => api('POST', `/v1/vehicles/${encodeURIComponent(vehicleId)}/authorizations`, body),
  revoke: (vehicleId, id) => api('DELETE', `/v1/vehicles/${encodeURIComponent(vehicleId)}/authorizations/${encodeURIComponent(id)}`),
  searchWorkshops: (q) => api('GET', `/v1/authorizations/workshops?q=${encodeURIComponent(q)}`),
  /** { code } ou { token } (conteúdo do QR) */
  activate: (body) => api('POST', '/v1/authorizations/activate', body),
  workshopVehicles: () => api('GET', '/v1/workshops/mine/vehicles'),
  workshopVehicle: (vehicleId) => api('GET', `/v1/workshops/mine/vehicles/${encodeURIComponent(vehicleId)}`),
};

/** Pedido de acesso pela placa (a oficina pede; o dono aceita ou recusa). */
export const accessRequests = {
  /** identifier: placa ou número de série (máquina agrícola). A validade do pedido vem do portal admin (requestTtlHours). */
  create: (identifier) => api('POST', '/v1/access-requests', { identifier }),
  /** Placas pedidas pela minha empresa: as 5 últimas ou, com q (2+ caracteres), as que têm o texto. Um item por veículo, com o último pedido. */
  sent: (q = '') => api('GET', `/v1/access-requests/sent${q ? `?q=${encodeURIComponent(q)}` : ''}`),
  /** Os 10 últimos pedidos do veículo daquele pedido (buscados ao abrir a linha). */
  history: (id) => api('GET', `/v1/access-requests/sent/${encodeURIComponent(id)}`),
  cancel: (id) => api('DELETE', `/v1/access-requests/${encodeURIComponent(id)}`),
  received: () => api('GET', '/v1/access-requests/received'),
  accept: (id, durationDays) => api('POST', `/v1/access-requests/${encodeURIComponent(id)}/accept`, { durationDays }),
  decline: (id) => api('POST', `/v1/access-requests/${encodeURIComponent(id)}/decline`),
};

export const AUTH_STATUS = {
  PENDING: { label: 'Aguardando a empresa', color: 'warning' },
  ACTIVE: { label: 'Autorizada', color: 'success' },
  EXPIRED: { label: 'Expirada', color: 'medium' },
  REVOKED: { label: 'Revogada', color: 'medium' },
};
export const DURATIONS = [1, 3, 7, 30];

const dateFmt = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
export const fmtDateTime = (v) => (v ? dateFmt.format(new Date(v)) : '');

/** "123456" → "123 456" */
export const spacedCode = (c) => `${c.slice(0, 3)} ${c.slice(3)}`;

/** mm:ss até a data (0:00 se passou) */
export function countdown(until, now = Date.now()) {
  const s = Math.max(0, Math.floor((new Date(until).getTime() - now) / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
